import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Icon } from "@circle-react-shared/Icon";
import { Typography } from "@circle-react-uikit/Typography";
import { Action } from "../Action";
import { useActionGroup } from "./useActionGroup";

export interface ActionGroupProps {
  actions: string[];
  className?: string;
  size?: "md" | "lg";
  truncationLimit?: number;
}

export const ActionGroup = ({
  actions: actionsProp = [],
  size = "lg",
  truncationLimit = 2,
  className,
}: ActionGroupProps) => {
  const { actions, remainingActionsCount, remainingItemsTooltip } =
    useActionGroup({
      actions: actionsProp,
      truncationLimit,
    });

  if (actionsProp.length === 0 || truncationLimit < 1) {
    return <div className="py-[25px] leading-none">-</div>;
  }

  const remainingText = `+${remainingActionsCount}`;

  return (
    <div
      className={classNames(
        "flex items-center",
        {
          "gap-1": size === "md",
          "gap-2": size === "lg",
        },
        className,
      )}
    >
      {actions.map(({ title, icon }, index) => (
        <Action tooltipContent={title} key={`${icon}-${index}`}>
          <div className="bg-tertiary flex size-8 max-h-8 max-w-[2rem] shrink-0 items-center justify-center rounded-full">
            <Icon
              type={icon}
              size={16}
              className="text-dark !h-4 !w-4 shrink-0"
            />
          </div>
        </Action>
      ))}
      {remainingActionsCount > 1 && (
        <Action tooltipContent={remainingItemsTooltip}>
          <div className="bg-tertiary flex size-8 max-h-8 max-w-[2rem] shrink-0 items-center justify-center rounded-full">
            <Typography.LabelSm weight="semibold">
              <span
                className={classNames("text-dark flex", {
                  "text-xxs": size === "md",
                })}
              >
                {remainingText}
              </span>
            </Typography.LabelSm>
          </div>
        </Action>
      )}
    </div>
  );
};
